import {Button} from '@mui/material'
import * as React from "react"
import Layout from '../../components/Layout'
import Section from '../../components/Section'

export default function IndexPage() {
  return (
    <Layout>
      <Section>
        <Button href='/osnovium/checklists'>Чеклисты</Button>
        <Button href='/osnovium/buy'>Купить курс</Button>
      </Section>
    </Layout>
  )
}
